import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

import { SERVER_URL } from "@/config/config";
import { CreditHistoryItem } from "@/types/CreditHistoryItem";

interface CreditHistoryState { items: CreditHistoryItem[]; isLoading: boolean; }
const initialState: CreditHistoryState = { items: [], isLoading: false };

export const getCreditHistory = createAsyncThunk(
  "creditHistory/getCreditHistory",
  async ({ address }: { address: string }) => {
    const response = await axios.get(`${SERVER_URL}/profile/creditHistory/${address}`);
    return response.data;
  }
);

const creditHistorySlice = createSlice({
  name: "creditHistory",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCreditHistory.pending, (state) => { state.isLoading = true; })
      .addCase(getCreditHistory.fulfilled, (state, { payload }) => { state.items = payload; state.isLoading = false; })
      .addCase(getCreditHistory.rejected, (state) => { state.isLoading = false; });
  },
});

export default creditHistorySlice.reducer;
